import { DeviceType } from 'core/constants';
import { ModelBase } from 'store/model-base';

export class NowLineDetails extends ModelBase {
    public static storeName: string = 'nowLineDetails';

    public lineDetailsHeader: NowLineDetailsHeader;
    public linePlanCard: NowLinePlanCard;
    public deviceCard: NowDeviceCard;
    public dataUsageCard: NowLineDetailDataUsageCard;
    public addOnsCard: NowAddOnCard;
    public moreOptions: NowMoreOptions;
    public heading: string;
    public noBillingSummary: boolean;
    public lineId: string;
    public offerId: string;
    public customerRelationshipId: string;
    public subscriptionId: string;
    public callAutopay: true;

    public isTablet: boolean;

    public static create<T extends ModelBase>(initData: ApiResponse): T {
        initData.isTablet = initData.lineDetailsHeader.deviceType.toUpperCase() === DeviceType.TABLET;

        return super.create<T>(initData);
    }

    public get isNumberLockEnabled(): boolean {
        return this.moreOptions.options.numberLock.subheaderContent.toUpperCase() === 'ON';
    }
}

